// src/constants/towers.js
export const TOWERS = [
    "Tower 1", "Tower 2", "Tower 3", "Tower 4", "Tower 5",
    "Tower 6", "Tower 7", "Tower 8", "Tower 9", "Tower 10",
    "Tower 11", "Tower 12", "Tower 13", "Tower 14", "Tower 15",
    "Signature Tower",
  ];
  
  export const UNIT_TYPES = ["A", "B", "C", "D", "E", "F"];
  
  export const FLOORS = Array.from({ length: 30 }, (_, i) => i + 1);